module.exports = __webpack_public_path__ + "static/media/icono_fotografia.ebecb3d3.svg";